import { render, staticRenderFns } from "./SubCompViewClient.vue?vue&type=template&id=17c18ed0&"
import script from "./SubCompViewClient.vue?vue&type=script&lang=js&"
export * from "./SubCompViewClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports